import { Injectable } from '@angular/core';
import axios from 'axios';
import { URL_AVAILABILITY_HOTEL, MOCK_URL_AVAILABILITY_HOTEL_PROPERTIES_AND_FACILITIES, MOCK_STATUS, MOCK_URL_AVAILABILITY_HOTEL, MOCK_URL_AVAILABILITY_HOTEL_ROOMS, URL_AVAILABILITY_HOTEL_ROOMS } from '@ibe.config';
import { INDRAApiService } from '@ibe/services';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { extendMoment } from 'moment-range';
import * as Moment from 'moment';

const moment = extendMoment(Moment);

@Injectable({
	providedIn: 'root'
})
export class INDRABookingComService {

	private version = '2.6';
	private base_url = 'https://distribution-xml.booking.com/';
	private url: string = `${this.base_url}${this.version}/json/`;
	private _hotel;

	public facilitiesAndProperties;
	public orderBy: string;
	public searchParam = {
		checkin: '',
		checkout: '',
		num_rooms: 0,
		room1: [],
		// room2: [],
		propertyType: [],
		hotelFacilities: [],
		minPrice: '',
		maxPrice: '',
		stars: [],
		locationValue: ''
	};

	constructor(private api: INDRAApiService, private http: HttpClient, private sanitizer: DomSanitizer) {

	}

	async blockAvailability(params: any = { checkin: '2020-06-01', checkout: '2020-06-30', hotel_ids: '257694' }) {
		// https://developers.booking.com/api/technical.html?version=2.3#!/Availability/blockAvailability
		const request = await this.request('blockAvailability', { params });
		return request;
	}

	async hotelAvailability(params: any = { city_ids: '-1565670', checkin: '2020-06-01', checkout: '2020-06-30', room1: 'A,A', extras: 'room_details,hotel_details', order_by: 'popularity', options: 'no_dorms' }) {
		// https://developers.booking.com/api/technical.html?version=2.3#!/Availability/hotelAvailability
		const request = await this.request('hotelAvailability', { params });
		return request;
	}

	async city(params: any = { countries: 'pt', languages: 'pt' }) {
		// https://developers.booking.com/api/technical.html?version=2.3#!/Static/cities
		const request = await this.request('cities', { params });
		return request;
	}

	async hotels(params: any) {
		// https://developers.booking.com/api/technical.html?version=2.5#!/Static/hotels
		const request = await this.request('hotels', { params });
		return request;
	}

	async regions(params: any) {
		// https://developers.booking.com/api/technical.html?version=2.5#!/Static/regions
		const request = await this.request('regions', { params });
		return request;
	}

	async autocomplete(params: any) {
		// https://developers.booking.com/api/technical.html?version=2.6#!/Static/autocomplete
		const request = await this.request('autocomplete', { params });
		return request;
	}

	private async request(endpoint, params, method = 'get') {

		const url = `${this.url}${endpoint}`;

		const defaultConfig = {
			baseURL: url,
			method,
			headers: {
				'Access-Control-Allow-Origin': '*',
			},
			auth: {
				username: 'uxdapi',
				password: 'uxdtap1t'
			},
			withCredentials: false,
			responseType: 'json'
		};

		const config = Object.assign(defaultConfig, params);
		const request = await axios.get(url, config);

		return request.data.result || false;

	}


	public INDRA_hotelAvailability(params): Observable<any> {
		if (MOCK_STATUS.AVAILABILITY_HOTEL) {
			return this.http.get(MOCK_URL_AVAILABILITY_HOTEL);
		} else {
			return this.api.INDRA_post<any>(URL_AVAILABILITY_HOTEL, params);
		}
	}

	public INDRA_blockAvailability(params): Observable<any> {
		if (MOCK_STATUS.AVAILABILITY_HOTEL_ROOMS) {
			return this.http.get(MOCK_URL_AVAILABILITY_HOTEL_ROOMS);
		} else {
			return this.api.INDRA_post<any>(URL_AVAILABILITY_HOTEL_ROOMS, params);
		}
	}

	public INDRA_getFacilitiesAndProperties() {
		return this.http.get(MOCK_URL_AVAILABILITY_HOTEL_PROPERTIES_AND_FACILITIES);
	}

	public INDRA_getGoogleLocation(address: string) {
		// const query = encodeURIComponent(address);
		// "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12451.321677960634!2d-9.158736573356403!3d38.721702214786895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd193378df121fc1%3A0xb57b449cd0d8a191!2sSanto%20Ant%C3%B3nio%2C%20Lisbon%2C%20Portugal!5e0!3m2!1sen!2sph!4v1591620991773!5m2!1sen!2sph"
		// `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12451.324594926295!2d-9.158736563706988!3d38.721685473568286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd193378df121fc1%3A0xb57b449cd0d8a191!2s${query}!5e0!3m2!1spt-PT!2spt!4v1580226794465!5m2!1spt-PT!2spt`
		// "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235666.45775262892!2d-43.44577868237182!3d-22.64303331183054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9972edfbe838f5%3A0x672bb060c280a52a!2sDuque%20de%20Caxias%2C%20State%20of%20Rio%20de%20Janeiro%2C%20Brazil!5e0!3m2!1sen!2sph!4v1591621131465!5m2!1sen!2sph"

		return this.sanitizer.bypassSecurityTrustResourceUrl(`https://maps.google.com/?q=${address}&output=embed`);
	}

	setHotel(hotel) {
		this._hotel = hotel;
	}

	getHotel() {
		return this._hotel;
	}

	setSearchParam(param) {
		this.searchParam = param;
	}

	getSearchParam() {
		return this.searchParam;
	}

	generateSearchParam(searchParam) {
		const room1 = [];
		for (let i = 0; i < searchParam.passengers.adults; i++) { room1.push('A'); }
		for (let i = 0; i < searchParam.passengers.youngAdults; i++) { room1.push('12'); }
		for (let i = 0; i < searchParam.passengers.children; i++) { room1.push('2'); }
		for (let i = 0; i < searchParam.passengers.infants; i++) { room1.push('0'); }

		return {
			checkIn: moment(searchParam.checkin).format('YYYY-MM-DD'),
			checkOut: moment(searchParam.checkout).format('YYYY-MM-DD'),
			room1: room1,
			num_rooms: searchParam.passengers.rooms,
			locationValue: searchParam.location.value
		};
	}

	resetSearchParam() {
		this.searchParam = {
			checkin: '',
			checkout: '',
			num_rooms: 0,
			room1: [],
			// room2: [],
			propertyType: [],
			hotelFacilities: [],
			minPrice: '',
			maxPrice: '',
			stars: [],
			locationValue: ''
		};
	}

	setOrderBy(orderBy) {
		this.orderBy = orderBy;
	}

	getOrderBy() {
		return this.orderBy;
	}


}
